<template>
	<v-app>
		<h1 style="text-align: center; padding: 15px">Rejestracja oferenta</h1>

		<user-with-this-nip-exists-dialog :nip-dialog="this.nipDialog" v-on:close="closeDialogs"/>

		<user-with-this-email-exists-dialog :email-dialog="this.emailDialog" v-on:close="closeDialogs"/>

		<organization-with-this-email-exists-dialog :organization-email-dialog="this.organizationEmailDialog"
			v-on:close="closeDialogs"/>

		<organization-with-this-name-exists-dialog :organization-names-dialog="this.organizationNamesDialog"
			v-on:close="closeDialogs"/>

		<v-stepper v-model="step" class="">
			<v-stepper-header>
				<v-stepper-step :complete="step > 0" step="1">Wybór formy prawnej</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 1" step="2">Dane podmiotu</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 2" step="3">Dane teleadresowe</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 3" step="4">Dane formalno-prawne</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 4" step="5">Dane konta głównego</v-stepper-step>
				<v-divider></v-divider>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content step="1">
					<StepChooseLegalFormComponent
						v-on:step="handleNextStep"
						v-bind:options="legalFormOptions"
						v-bind:step-data="formData.firstStep"/>
					<v-alert
						:value="firstStepErrorShowed"
						color="error"
						icon="warning"
						outline
					>
						Forma prawna musi być wybrana
					</v-alert>
				</v-stepper-content>
				<v-stepper-content step="2">
					<StepChooseOrganizationName
						v-on:step="handleNextStep"
						v-bind:step-data="formData.secondStep"/>
				</v-stepper-content>
				<v-stepper-content step="3">
					<StepAddressDataComponent v-on:step="handleNextStep"
						v-bind:step-data="formData.thirdStep"/>
				</v-stepper-content>
				<v-stepper-content step="4">
					<StepFormalDataComponent v-bind:step-data="formData.fourthStep"
						v-bind:has-krs="hasKrs"
						v-on:step="handleNextStep"/>
				</v-stepper-content>
				<v-stepper-content step="5">
					<StepUserDataComponent v-bind:step-data="formData.fifthStep"
						v-on:register="register"
						v-on:step="handleNextStep"/>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
		<v-footer
			primary color="white"
			class="elevation-2 d-flex"
			absolute
		>
			<div class="my-3 regulation">
				<a href="/declaration.html">
					Deklaracja dostępności
				</a>
			</div>	
		</v-footer>
	</v-app>
</template>

<script>
	import StepChooseLegalFormComponent from "./components/StepChooseLegalFormComponent";
	import StepChooseOrganizationName from "./components/StepChooseOrganizationNameComponent";
	import StepAddressDataComponent from "./components/StepAddressDataComponent";
	import StepFormalDataComponent from "./components/StepFormalDataComponent";
	import StepUserDataComponent from "./components/StepUserDataComponent";
	import UserWithThisNipExistsDialog from "./UserWithThisNipExistsDialog";
	import UserWithThisEmailExistsDialog from "./UserWithThisEmailExistsDialog";
	import OrganizationWithThisEmailExistsDialog from "./OrganizationWithThisEmailExistsDialog";
	import {encoder} from "@/utils/encodeHelper";
	import OrganizationWithThisNameExistsDialog from "./OrganizationWithThisNameExistsDialog";
  import {UserRegister} from "@/api/generated/UserRegister";
  import {Bidder} from "@/api/generated/Bidder";

	export default {
		name: "RegisterBidder",
		components: {
			OrganizationWithThisNameExistsDialog,
			OrganizationWithThisEmailExistsDialog,
			UserWithThisEmailExistsDialog,
			UserWithThisNipExistsDialog,
			StepFormalDataComponent,
			StepAddressDataComponent,
			StepChooseOrganizationName,
			StepChooseLegalFormComponent,
			StepUserDataComponent,
		},

		mounted() {
			this.$root.$on("krsValueChanged", (krsValue) => {
				this.hasKrs = krsValue;
			});

		},

		provide() {
			return {parentValidator: this.$validator};
		},

		methods: {
			register() {
				Bidder.post(this, this.prepareData(), response => {
					if (response !== undefined && response.status === "OK") {
						this.$router.push("/register-completed?email=".concat(encoder.encodeUrlParam(this.formData.fifthStep.email)));
					} else {
						this.formData.thirdStep.websiteAddress = decodeURIComponent(escape(atob(this.formData.thirdStep.websiteAddress)));
						this.$router.push("/error");
					}
				});
			},

			prepareData () {
				this.formData.thirdStep.websiteAddress = btoa(unescape(encodeURIComponent(this.formData.thirdStep.websiteAddress)));
				return this.formData;
			},

			validateNip() {
        UserRegister.getValidateNipUniqueness(this, this.formData.firstStep.nip, successResponse => {
          if (successResponse) {
            this.step = 2;
          } else {
            this.nipDialog = true;
          }
        }, errorResponse => {
          let errorMessage = errorResponse.status === "TOO_MANY_REQUESTS"
              ? "Wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
              : "Wystąpił błąd podczas walidacji numeru NIP";
          this.$messagesBus.$emit("error", errorMessage, errorResponse);
        });
			},

			validateEmail() {
				UserRegister.getValidateUserEmailUniqueness(this, encoder.encodeUrlParam(this.formData.fifthStep.email), successResponse => {
						if (successResponse.unique === false) {
							this.emailDialog = true;
						} else {
							this.register();
						}
					}, errorResponse => {
              let errorMessage = errorResponse.status === "TOO_MANY_REQUESTS"
                  ? "Wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
                  : "Wystąpił błąd podczas walidacji adresu e-mail";
              this.$messagesBus.$emit("error", errorMessage, errorResponse);
            });
			},

			validateOrganizationEmail() {
				UserRegister.getValidateOrganizationEmailUniqueness(this, encoder.encodeUrlParam(this.formData.thirdStep.organizationEmail), successResponse => {
					if (successResponse.unique === false) {
						this.organizationEmailDialog = true;
					} else {
						this.step = 4;
					}
				}, errorResponse => {
          let errorMessage = errorResponse.status === "TOO_MANY_REQUESTS"
              ? "Wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
              : "Wystąpił błąd podczas walidacji adresu e-mail";
          this.$messagesBus.$emit("error", errorMessage, errorResponse);
        });
			},

			validateOrganizationNames () {
				UserRegister.getValidateOrganizationNamesUniqueness(this, this.formData.secondStep.polishName, this.formData.secondStep.englishName, successResponse => {
					if (successResponse === false) {
						this.organizationNamesDialog = true;
					} else {
						this.step = 3;
					}
				}, errorResponse => {
          let errorMessage = errorResponse.status === "TOO_MANY_REQUESTS"
              ? "Wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
              : "Wystąpił błąd podczas walidacji nazwy podmiotu";
          this.$messagesBus.$emit("error", errorMessage, errorResponse);
        });
			},

			handleNextStep(step, scope) {
				this.firstStepErrorShowed = false;
				if (step > this.step) {
					this.$validator.validateAll(scope).then(result => {
						if (step === 2) {
							if (result === false) return;
							if (this.formData.firstStep.legalForm.type === undefined) {
								this.firstStepErrorShowed = true;
								return;
							}
							this.validateNip();
						} else if (step === 3) {
							if (result) this.validateOrganizationNames();
						} else if (step === 4) {
							if (result) this.validateOrganizationEmail();
						} else if (step === 6) {
							if (result) this.validateEmail();
						} else if (result) {
							this.step = step;
						}
					});
				} else {
					this.step = step;
				}
			},

			closeDialogs() {
				this.nipDialog = false;
				this.organizationEmailDialog = false;
				this.organizationNamesDialog = false;
				this.emailDialog = false;
			},
		},

		data() {
			return {
				firstStepErrorShowed: false,
				nipDialog: false,
				emailDialog: false,
				organizationEmailDialog: false,
				organizationNamesDialog: false,
				step: 1,
				hasKrs: false,
				formData: {
					firstStep: {
						legalForm: {
							type: undefined,
							subtype: undefined,
							id: "",
						},
						nip: "",
					},
					secondStep: {
						polishName: "",
						englishName: "",
						representativePerson: {
							name: "",
							surname: "",
							position: "",
						},

						secondRepresentativePerson: {
							name: "",
							surname: "",
							position: "",
						},
					},

					thirdStep: {
						address: {
							street: "",
							building: "",
							apartment: "",
							postalCode: "",
							city: "",
						},

						correspondenceAddress: {
							street: "",
							building: "",
							apartment: "",
							postalCode: "",
							city: "",
						},

						province: "",
						correspondenceProvince: "",

						websiteAddress: "",
						organizationEmail: "",
						phoneNumber: "",
					},

					fourthStep: {
						numberType: "",
						number: "",
						krs: "",
					},

					fifthStep: {
						name: "",
						surname: "",
						phoneNumber: "",
						email: "",
						bidderContactMail: ""
					},
				},
				legalFormOptions: {
					nonGovernmentSector: {
						name: "Sektor pozarządowy",
						options: [
							"Fundacja",
							"Stowarzyszenie",
              "Stowarzyszenie samorządowe",
              "Stowarzyszenie kultury fizycznej",
              "Związek stowarzyszeń",
              "Stowarzyszenie zwykłe",
							"Organizacja kościelna",
							"Spółdzielnia socjalna",
							"Spółka non-profit",
							"Klub sportowy",
              "Izba gospodarcza",
              "Izba rolnicza",
							"Inny podmiot",
						],
					},
					scienceInstitution: {
						name: "Instytucja naukowa",
						options: [
							"Publiczna szkoła wyższa",
							"Niepubliczna szkoła wyższa",
							"Instytut badawczy",
							"Polska Akademia Nauk",
							"Krajowa Szkoła Administracji Publicznej",
							"Inna instytucja",
						],
					},

					governmentOrganization: {
						name: "Organ administracji rządowej",
						options: [
							"Ministerstwo",
							"Urząd centralny",
							"Urząd wojewódzki",
							"Inny organ",
						],
					},

					territoryIndividual: {
						name: "Jednostka samorządu terytorialnego",
						options: [
							"Gmina",
							"Powiat",
							"Województwo",
							"Inna jednostka",
						],
					},
				},
			};
		},
	};
</script>

<style scoped>
	.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		height: 85px !important;
	}
</style>